import { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { FormBlock } from '@/components/FormBlock';
import { useZustandSync } from '@/hooks/useZustandSync';
import useProductStore, { productStore } from '@/stores/productStore';

import { ImageSelector } from '../form/ImageSelector';
import ReviewImage from './ReviewMode/ReviewImage';

const imageSchema = z.object({
  image: z.string('Adicione uma imagem ao produto.').nonempty('Adicione uma imagem ao produto.')
});

type ImageFormValues = z.infer<typeof imageSchema>;

const FIELD_NAME = 'image';

export default function Image() {
  const form = useForm<ImageFormValues>({
    resolver: zodResolver(imageSchema),
    mode: 'onChange',
    defaultValues: { [FIELD_NAME]: useProductStore(d => d[FIELD_NAME]) }
  });

  const initialValue = useRef(form.control._defaultValues[FIELD_NAME]);

  const store = productStore.getState();
  const productImage = useProductStore(d => d[FIELD_NAME]);

  useZustandSync<ImageFormValues>(form.control, data => ({
    [FIELD_NAME]: data[FIELD_NAME]
  }));

  useEffect(() => {
    if (productImage === initialValue.current) {
      return;
    }

    store.setIaField('product-image', false);
  }, [productImage, store]);

  return (
    <FormBlock name='product-image' form={form} title='Imagem' preview={<ReviewImage />}>
      <ImageSelector name={FIELD_NAME} size={200} />
    </FormBlock>
  );
}
